import { getDashboardPublicUrl } from './getDashboardPublicUrl.js';

/** Host path shown on the TV pairing instructions (e.g. dashboard.ghostscreens.com/pair). */
export function getDashboardPairLabel(): string {
  try {
    return `${new URL(getDashboardPublicUrl()).host}/pair`;
  } catch {
    return 'dashboard.ghostscreens.com/pair';
  }
}
